import React, {useEffect} from 'react';
import '../style/css/components/Sobre.css';
import '../style/css/components/Timeline.css';
import imgLucas from '../img/lp-2024.png';
import Breadcrumb from "./Breadcrumb";
import {staggeredFadeInDivEffect} from "./staggeredFadeInDivEffect";
import {BackToTop} from "./BackToTop";

function Sobre(){

	useEffect(()=>{
		BackToTop();
		staggeredFadeInDivEffect(50)
	})

	let experienciaProfissional = [
		{
			periodo: 'Novembro/2015 - Dezembro/2016',
			instituicao: 'SixHandsDesign',
			localidade: 'São Gonçalo - RJ',
			funcao: 'Front-End',
			homeoffice: '',
			tecnologias: [
				'HTML5',
				'CSS3'
			]
		},
		{
			periodo: 'Janeiro/2016 - Novembro/2016',
			instituicao: 'ML Digital Arts',
			localidade: 'São Gonçalo - RJ',
			funcao: 'Front-End e UI/UX Designer',
			homeoffice: '',
			tecnologias: [
				'HTML5',
				'CSS3',
				'JavaScript',
				'Adobe Illustrator',
				'Adobe Photoshop',
			]
		},
		{
			periodo: 'Novembro/2016 - Fevereiro/2018',
			instituicao: 'Medilab Sistemas',
			localidade: 'Tijuca - RJ',
			funcao: 'Front-End e UI/UX Designer',
			homeoffice: '',
			tecnologias: [
				'HTML5',
				'CSS3',
				'JavaScript',
				'Adobe Illustrator',
				'Adobe Photoshop',
				'Adobe InDesign'
			]
		},
		{
			periodo: 'Fevereiro/2018 - Fevereiro/2019',
			instituicao: 'GM5 Informática',
			localidade: 'Barra da Tijuca - RJ',
			funcao: 'Front-End',
			homeoffice: '',
			tecnologias: [
				'HTML5',
				'CSS3',
				'Less CSS',
				'JavaScript',
				'jQuery',
				'PHP',
				'WordPress',
				'Lumis'
			]
		},
		{
			periodo: 'Março/2019 - Fevereiro/2021',
			instituicao: 'Eleven Consultoria',
			localidade: 'Niterói - RJ',
			funcao: 'Full Stack [ PHP + Laravel ] ',
			homeoffice: ' - Home office',
			tecnologias: [
				'HTML5',
				'CSS3',
				'Less CSS',
				'JavaScript',
				'PHP',
				'MySql',
				'Microsoft SQL Server',
				'WordPress',
				'Totvs RM',
				'Vtiger CRM',
				"API's",
				'Laravel',
				'Linux Ubuntu'
			]
		},
		{
			periodo: 'Fevereiro/2021 - Junho/2021',
			instituicao: 'GM5 Informática',
			localidade: 'Barra da Tijuca - RJ',
			funcao: 'Back-End [ PHP + Laravel ]',
			homeoffice: ' - Home office',
			tecnologias: [
				'HTML5',
				'Sass CSS',
				'PHP',
				'MySql',
				"API's",
				'Laravel',
				'Linux Ubuntu',
				'WSL'
			]
		},
		{
			periodo: 'Junho/2021 - até o momento',
			instituicao: 'Mesha Technology',
			localidade: 'Maceió - AL',
			funcao: 'Full Stack [ PHP + Laravel ]',
			homeoffice: ' - Home office',
			tecnologias: [
				"API's",
				'Laravel',
				'MySql',
				'Linux Ubuntu',
				'WSL',
				'Docker',
				'JavaScript',
				'Next.js',
				'React',
				'Sass CSS',
			]
		},
	];
	let cursos = [
		{
			nome: 'Front-End',
			instituicao: 'COTI Informática',
			periodo: 'Junho/2014 - Dezembro/2015'
		},
		{
			nome: 'Web Design',
			instituicao: 'COTI Informática',
			periodo: 'Março/2015 - Maio/2015'
		},
		{
			nome: 'PHP + MySQL + Ajax',
			instituicao: 'COTI Informática',
			periodo: 'Maio/2015 - Junho/2015'
		},
		{
			nome: 'PHP e MySQL',
			instituicao: 'Hcode/Udemy',
			periodo: '2018'
		},
		{
			nome: 'MVC no PHP',
			instituicao: 'Alura',
			periodo: '2020'
		},
		{
			nome: 'Laravel',
			instituicao: 'Alura',
			periodo: '2020'
		},
		{
			nome: 'Design Patterns em PHP',
			instituicao: 'Alura',
			periodo: '2021'
		},
		{
			nome: 'React',
			instituicao: 'Alura',
			periodo: '2021'
		},
	];

	return (
		<div className='fade-enter'>
			<Breadcrumb page='Sobre mim'/>

			<h1 className='fade-enter'>Sobre mim</h1>

			<div className="row">
				<div className="col">
					<div className="fade-enter">
						<div className="imgWrapp">
							<img src={imgLucas} alt="Lucas Pedro" loading='lazy' />
						</div>
					</div>
				</div>
			</div>

			<div className="row">
				<div className="col">
					<div className="card card_Exp_Cursos fade-enter">
						<div className="container">
							<div className="row">

								<div className="col-12 fade-enter">
									<h3 className='pageTitle'>Quem é o Lucas?</h3>
									<hr/>
									<div className="fade-enter">
										<p className="text_WhoAmI">
											Sou um programador full stack com mais de <span>10 anos</span> de experiência em desenvolvimento web, especializado em <span>Laravel (PHP)</span> e <span>Next.js (React)</span>.
										</p>
										<p className="text_WhoAmI">
											Apaixonado por <span>código limpo</span>, <span>escalabilidade</span> e <span>performance</span>, já integrei e liderei projetos complexos, integrando sistemas robustos com APIs e <span>bancos de dados otimizados</span> para grande volume de dados. Gosto de resolver problemas e criar <span>aplicações intuitivas</span> e <span>eficientes</span>.
										</p>
										<p className="text_WhoAmI">
											Atualmente, foco na criação de aplicações modernas com <span>arquitetura escalável</span> e <span>práticas ágeis</span>.
										</p>
									</div>
								</div>

							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="row">
				<div className="col-12">
					<div className="card fade-enter">
						<div className="row">
							<div className="col-12 fade-enter">
								<h3 className="pageTitle">Carreira</h3>
								<hr/>
							</div>
							<div className="col-12">
								<div className="row">
									<div className="col col-md-6">
										<div className="card card_Exp_Cursos fade-enter">
											<div className="container">
												<div className="row">

													<div className="col-12 fade-enter">
														<h3 className='pageTitle'>Experiência Profissional</h3>
													</div>

													<div className="col-12 fade-enter">
														<div className="rightbox">
															<div className="rb-container">
																<ul className="rb">
																	{
																		experienciaProfissional.map((item, index) => {
																			return (
																				<li className="rb-item" ng-repeat="itembx" key={index}>
																					<div className="timestamp">
																						Período:
																						<br/>
																						{item.periodo}
																					</div>
																					<div className="item-title">
																						<h4>{item.funcao}</h4>
																						<p>
																							<strong>Instituição: </strong>{item.instituicao} <small>({item.localidade}){item.homeoffice}</small>
																						</p>
																						<p>
																							<strong>Tecnologias utilizadas: </strong>
																							<br/>
																							{
																								item.tecnologias.map((stack, indexStack) => {
																									return (
																										<span className='badgeTech' key={indexStack}>{stack}</span>
																									);
																								})
																							}
																						</p>
																					</div>
																				</li>
																			)
																		})
																	}
																</ul>
															</div>
														</div>
													</div>

												</div>
											</div>
										</div>
									</div>
									<div className="col col-md-6">
										<div className="card card_Exp_Cursos fade-enter">
											<div className="container">
												<div className="row">

													<div className="col-12 fade-enter">
														<h3 className='pageTitle'>Cursos</h3>
													</div>

													<div className="col-12 fade-enter">
														<div className="rightbox">
															<div className="rb-container">
																<ul className="rb">
																	{
																		cursos.map((item, index) => {
																			return (
																				<li className="rb-item" ng-repeat="itembx" key={index}>
																					<div className="timestamp">
																						Período:
																						<br/>
																						{item.periodo}
																					</div>
																					<div className="item-title">
																						<h4>{item.nome}</h4>
																						<p>
																							<strong>Instituição: </strong>{item.instituicao}
																						</p>
																					</div>
																				</li>
																			)
																		})
																	}
																</ul>
															</div>
														</div>
													</div>

												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

		</div>
	);
}

export default Sobre;
